import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import InputEmail from "../../helpers/InputEmail";
import InputCombo from "../../helpers/InputCombo";
import InputTime from "../../helpers/InputTime";
import InputPhone from "../../helpers/InputPhone";
import InputInteger from "../../helpers/InputInteger";



function Settings(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [row, setRow] = useState(null);



 
 

    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,pl_settings', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setRow(res.result);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }





    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


   
    const valChangeListener = (filedName, val, correct, msg) => {

       

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

      

        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const saveData = () => {
 

        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

       
   
                            props.mainView.setProgress(-2);

                          

                            fetch( Config.url + '/rest_v1,pl_up_settings', {
                                method: 'POST', 
                                body: JSON.stringify(row), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {             
                                        
                                        props.mainView.setProgress(-1);

                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                        // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        setErrTab(res.result);
                                        }else
                                        if(res.status != undefined && res.status == "OK")
                                        {
                                            props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                                                              
                                        }else
                                        {
                                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                        }
                                    
                            } )
                            .catch(err => {   
                                        props.mainView.setProgress(-1);       
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            });
              

         return false;

    }




    if(row == null)
    {
        setRow([]);
        getData();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setRow(null);
        }         

     
        var itemsTermin = [
            {v: 1, title: "Dzień przed"   },
            {v: 2, title: "W dniu nieobecności dziecka"   },
        ];


        var itemsWeekend = [
            {v: 0, title: "---"   },
            {v: 1, title: "Sobota, niedziela - zawsze po czasie"   },
            {v: 'A', title: "Sobota  do 10:00, niedziela zawsze po czasie"   },
            {v: 'B', title: "Sobota  do 11:00, niedziela zawsze po czasie"   },
            {v: 'C', title: "Sobota  do 12:00, niedziela zawsze po czasie"   },
            {v: 'D', title: "Śniadania I/II do 15:00 PT,  Obiad do 9:00 w dniu nieobecności"   },
        ];


        var itemsCateringOpcja = [
            {v: 0, title: "Nie"   },
            {v: 1, title: "Tak, Wyslij e-mail z liczbą posiłków do przygotowania"   },        
            {v: 2, title: "Tak, Wyślij wiadomość SMS z łączną liczbą posiłków (bez podziału na stawki)"   },        
            {v: 3, title: "Tak, Wyślij wiadomość SMS z łączną liczbą posiłków (wiele stawek żywieniowych)"   },        
            {v: 4, title: "Tak, Wyślij wiadomość e-mail - posiłki imienne"   },                       
        ];

        
        var itemsCateringPrac = [
            {v: 0, title: "Domyślnie - dokładnie dzień jeden przed"   },                
        ];

        
    var vatPodstawa = [
        {
            v: 'netto',
            title: 'Netto'
        },
        {
            v: 'brutto',
            title: 'Brutto'
        }
    ]; 

    
    var typDokumentu = [
        {
            v: 'f',
            title: 'Faktura'
        },
        {
            v: 'r',
            title: 'Zwykłe rozliczenie'
        }
    ];   


    var terminyPlatnosci = [
        {
            v: '0',
            title: 'Podana ilość dni od daty wystawienia'
        },
        {
            v: '1',
            title: 'Podany dzień miesiąca'
        }
    ]; 
    
    
    var itemsActive = [
        {
            v: '0',
            title: 'Nieaktywny'
        },
        {
            v: '1',
            title: 'Aktywny'
        }
    ]; 
    

    var itemsWall = [
        {
            v: '0',
            title: 'Dyrektor + Opiekunowie + Rodzice'
        },
        {
            v: '1',
            title: 'Dyrektor'
        },
        {
            v: '2',
            title: 'Dyrektor + Opiekunowie'
        }
    ]; 



    var itemsPrac = [
        {
            v: '0',
            title: 'Pełna lista pracowników'
        },
        {
            v: '1',
            title: 'Tylko opiekun grupy'
        }
    ]; 
    

    var itemsGr = [
        {
            v: '0',
            title: 'Nie'
        },
        {
            v: '1',
            title: 'Tak (Chat pomiędzy pracownikami i Chat rodzic -> pracownicy)'
        }
    ]; 


    var itemsAnZg = [
        {
            v: '0',
            title: 'Nie - pozostaw bez zmian'
        },
        {
            v: '1',
            title: 'Tak, anuluj wszystkie zgłoszone (tego dnia)'
        }
    ]; 


    var itemsSMSUpr = [
        {
            v: '0',
            title: 'Nie - nie wysyłaj'
        },
        {
            v: '1',
            title: 'Tak, wysyłaj SMSy do osoby upoważnionej'
        }
    ]; 


    return (
        <div className="view_content">
         

                    <form className="eForm bg_center">
                            
                            <div className="form_tab_title">Posiłki i nieobecności:</div>
                            <div className="form_tab">
                         

                            <div className="form_control">
                                        <div className="fieldName">Do kiedy rodzic musi zgłosić nieobecność:</div>                                       
                                        <InputCombo  items={itemsTermin} userData={props.userData} value={row.termin_zgloszenia_nieobecnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_zgloszenia_nieobecnosci" placeholder={""} className=' w200 '  />
                                    </div>
 
                                    <div className="form_control">
                                        <div className="fieldName">Do godziny: </div>                                
                                        <InputTime userData={props.userData} value={row.godzina_zgloszenia_nieobecnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_zgloszenia_nieobecnosci" placeholder={""} className='  '  />                                  
                                    </div>

                                    <br/>

                                    
                                    <div className="form_control">
                                        <div className="fieldName">Weekend:</div>                                          
                                        <InputCombo  items={itemsWeekend} userData={props.userData} value={row.nb_zgloszenie_weekend} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nb_zgloszenie_weekend" placeholder={""} className=' w400 '  />                                 
                                    </div>


                            </div>









                            <div className="form_tab_title">Catering / Firma zewnętrzna:</div>
                            <div className="form_tab">
                         
                                            <div className="form_control">
                                                <div className="fieldName">Czy wysłać zamówienie do firmy cateringowej? </div>                                               
                                                <InputCombo  items={itemsCateringOpcja} userData={props.userData} value={row.catering_opcja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="catering_opcja" placeholder={""} className=' w400 '  /> 
                                            </div>

                                            {
                                                (row.catering_opcja == 1 || row.catering_opcja == 4) &&
                                                    <div className="form_control">
                                                        <div className="fieldName">Adres e-mail </div>
                                                        <InputEmail   userData={props.userData} value={row.catering_email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="catering_email" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='1' firstUp="1" />
                                                    </div>
                                            }

                                            {
                                                (row.catering_opcja == 2 || row.catering_opcja == 3) &&
                                                    <div className="form_control">
                                                        <div className="fieldName">Numer telefonu </div>
                                                        <InputPhone   userData={props.userData} value={row.catering_email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="catering_email" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='1' firstUp="1" />
                                                    </div>
                                            }


                                    <div className="form_control">
                                        <div className="fieldName">Godzina wysyłki: </div>                                
                                        <InputTime userData={props.userData} value={row.catering_godzina} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="catering_godzina" placeholder={""} className='  '  />                                  
                                    </div>

                                    <div className="form_control">
                                        <div className="fieldName">Druga godzina wysyłki: </div>                                
                                        <InputTime userData={props.userData} value={row.catering_godzina2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="catering_godzina2" placeholder={""} className='  '  />                                  
                                    </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Catering - pracownik, do kiedy zgłosił zapotrzebowanie na posiłek </div>                                               
                                                <InputCombo  items={itemsCateringPrac} userData={props.userData} value={row.pracownik_catering} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pracownik_catering" placeholder={""} className=' w400 '  /> 
                                            </div>

                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>zapisz zmiany</div>                                   
                            </div>




                            <div className="form_tab_title">Rozliczenia i faktury:</div>
                            <div className="form_tab">

                                        
                                    <div className="form_control">
                                        <div className="fieldName">Domyślny typ dokumentów*</div>
                                        <InputCombo  items={typDokumentu}  value={row.typ_dokumentu} valChange={valChangeListener} goNext={null} name="typ_dokumentu" placeholder={ "Typ: "} className='  ' req='1' />
                                    </div>
                                    
                            

                                    {
                                        row.typ_dokumentu == 'f' &&
                                        <Fragment>
                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Podstawa dla VAT*</div>
                                                        <InputCombo  items={vatPodstawa}  value={row.faktura_vat_postawa} valChange={valChangeListener} goNext={null} name="faktura_vat_postawa" placeholder={ ": "} className='  ' req='1' />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Informacja na fakturze (np. zwolnienie z VAT na podstawie....)</div>
                                                        <InputText    userData={props.userData}  value={row.faktura_vat_info} valChange={valChangeListener} goNext={null} name="faktura_vat_info" placeholder={ "Info: "} className=' w300' req='0' />
                                                    </div>


                                        </Fragment>
                                    }


                                    {
                                        row.typ_dokumentu == 'r' &&
                                        <Fragment>
                                                    <div className="form_split"></div>
        

                                                    <div className="form_control">
                                                        <div className="fieldName">Informacja na rozliczeniu (np. zwolnienie z VAT na podstawie....)</div>
                                                        <InputText    userData={props.userData}  value={row.rozliczenie_info} valChange={valChangeListener} goNext={null} name="rozliczenie_info" placeholder={ "Info: "} className=' w300' req='0' />
                                                    </div>


                                        </Fragment>
                                    }


                                    <div className="form_split"></div>

                                    <div className="form_control">
                                        <div className="fieldName">Domyślny termin płatności*</div>
                                        <InputCombo  items={terminyPlatnosci}  value={row.termin_pl_opcja} valChange={valChangeListener} goNext={null} name="termin_pl_opcja" placeholder={ ": "} className='  ' req='1' />
                                    </div>

                                    {
                                        row.termin_pl_opcja == 0 &&
                                        <div className="form_control">
                                            <div className="fieldName">Ilość dni od daty wystawienia (1-30)</div>
                                            <InputInteger userData={props.userData} min="1" max="30" value={row.termin_pl_dni} valChange={valChangeListener} goNext={null} name="termin_pl_dni" placeholder={ ": "} className=' w50' req='1' />
                                        </div>
                                    }
                                    

                                    {
                                        row.termin_pl_opcja == 1 && 
                                        <div className="form_control">
                                            <div className="fieldName">Dzień miesiąca (3-28) </div>
                                            <InputInteger userData={props.userData}  min="3" max="28" value={row.termin_pl_dzien} valChange={valChangeListener} goNext={null} name="termin_pl_dzien" placeholder={ ": "} className=' w50' req='1' />
                                        </div>  
                                    }


                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>zapisz zmiany</div>                                   
                            </div>





                            <div className="form_tab_title">Elektroniczna rejestracja wejść / wyjść:</div>
                            <div className="form_tab">


                                            <div className="form_control">
                                                <div className="fieldName">Nazwa WiFi (min. 6 znaków) lub 'brak' </div>
                                                <InputText   userData={props.userData} value={row.nazwa_wifi} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa_wifi" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">ID Beacon (min. 6 znaków) lub 'brak' </div>
                                                <InputText   userData={props.userData} value={row.nazwa_bicoin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa_bicoin" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">RogerUQ (min. 8 znaków)</div>
                                                <InputText   userData={props.userData} value={row.roger_uq} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="roger_uq" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Anulować nieobecność po odbiciu karty?*</div>
                                                <InputCombo  items={itemsAnZg}  value={row.anulowanie_nb_karta} valChange={valChangeListener} goNext={null} name="anulowanie_nb_karta" placeholder={ ": "} className='  ' req='1' />
                                            </div>

                            </div>

                            <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany</div>                                   
                                </div>





                            <div className="form_tab_title">Komunikacja:</div>
                            <div className="form_tab">

                                    <div className="form_control">
                                        <div className="fieldName">Kto może publikować informacje*</div>
                                        <InputCombo  items={itemsWall}  value={row.publkacja_na_tablicy} valChange={valChangeListener} goNext={null} name="publkacja_na_tablicy" placeholder={ ": "} className='  ' req='1' />
                                    </div>


                                    <div className="form_split"></div>
 
                                    <div className="form_control">
                                        <div className="fieldName">Moduł komunikacji (korespondencja, chat)**</div>
                                        <InputCombo  items={itemsActive}  value={row.modul_korespondencja} valChange={valChangeListener} goNext={null} name="modul_korespondencja" placeholder={ ": "} className='  ' req='1' />
                                    </div>
                      
                                    <div className="form_control">
                                        <div className="fieldName">Korespondencja rodzice - pracownicy*</div>
                                        <InputCombo  items={itemsPrac}  value={row.wiadomosci_tylko_z_opiekunem} valChange={valChangeListener} goNext={null} name="wiadomosci_tylko_z_opiekunem" placeholder={ ": "} className='  ' req='1' />
                                    </div>

                                    <div className="form_control">
                                        <div className="fieldName">Grupy Chat*</div>
                                        <InputCombo  items={itemsGr}  value={row.grupy_chat} valChange={valChangeListener} goNext={null} name="grupy_chat" placeholder={ ": "} className='  ' req='1' />
                                    </div>

                                    <div className="">
                                       ** Wyłączony moduł komunikacji oznacza brak możliwości korzystania z koresponencji i chatów w panelu rodzica i pracownika. 
                                    </div>
                                    

                            </div>


                            <div className="form_tab_title">Odbiór dziecka:</div>
                            <div className="form_tab">
                                     <div className="form_control">
                                        <div className="fieldName">Po dodaniu osoby upowżnionej wyślij do niej SMS z informacją o możliwości odbioru dziecka*</div>
                                        <InputCombo  items={itemsSMSUpr}  value={row.send_sms_os_upowazniona} valChange={valChangeListener} goNext={null} name="send_sms_os_upowazniona" placeholder={ ": "} className='  ' req='1' />
                                    </div>
                            </div>






                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>zapisz zmiany</div>                                   
                            </div>


                    </form>


 

        </div>
    )
}

export default Settings;

